const VENUE_DASHBOARD_CACHE_TTL_MS = 10 * 60 * 1000;
/** Bump when cached bundle shape changes (e.g. catalog item tags). */
const CACHE_SCHEMA_VERSION = 2;
const SESSION_STORAGE_PREFIX = `occasia:venue-dashboard-bundle:v${CACHE_SCHEMA_VERSION}:`;
const venueDashboardCache = new Map();

const readSessionBundle = (venueId) => {
  const key = venueId != null ? String(venueId) : '';
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(`${SESSION_STORAGE_PREFIX}${key}`);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry?.bundle || !entry?.fetchedAt) return null;
    if (Date.now() - entry.fetchedAt > VENUE_DASHBOARD_CACHE_TTL_MS) {
      sessionStorage.removeItem(`${SESSION_STORAGE_PREFIX}${key}`);
      return null;
    }
    return entry;
  } catch {
    return null;
  }
};

const writeSessionBundle = (venueId, bundle, fetchedAt = Date.now()) => {
  const key = venueId != null ? String(venueId) : '';
  if (!key || !bundle) return;
  try {
    sessionStorage.setItem(
      `${SESSION_STORAGE_PREFIX}${key}`,
      JSON.stringify({ bundle, fetchedAt })
    );
  } catch {
    // Quota exceeded or private mode — in-memory cache still works.
  }
};

const removeSessionBundle = (venueId) => {
  const key = venueId != null ? String(venueId) : '';
  if (!key) return;
  try {
    sessionStorage.removeItem(`${SESSION_STORAGE_PREFIX}${key}`);
  } catch {
    // ignore
  }
};

export const getCachedVenueDashboardBundle = (venueId) => {
  const key = venueId != null ? String(venueId) : '';
  if (!key) return null;

  const memoryEntry = venueDashboardCache.get(key);
  if (memoryEntry) {
    if (Date.now() - memoryEntry.fetchedAt > VENUE_DASHBOARD_CACHE_TTL_MS) {
      venueDashboardCache.delete(key);
    } else {
      return memoryEntry.bundle;
    }
  }

  const sessionEntry = readSessionBundle(key);
  if (sessionEntry?.bundle) {
    venueDashboardCache.set(key, sessionEntry);
    return sessionEntry.bundle;
  }

  return null;
};

export const setCachedVenueDashboardBundle = (venueId, bundle) => {
  const key = venueId != null ? String(venueId) : '';
  if (!key || !bundle) return;
  const entry = { bundle, fetchedAt: Date.now() };
  venueDashboardCache.set(key, entry);
  writeSessionBundle(key, bundle, entry.fetchedAt);
};

export const clearVenueDashboardCache = (venueId) => {
  if (venueId != null) {
    const key = String(venueId);
    venueDashboardCache.delete(key);
    removeSessionBundle(key);
    return;
  }
  venueDashboardCache.clear();
  try {
    Object.keys(sessionStorage).forEach((storageKey) => {
      if (storageKey.startsWith(SESSION_STORAGE_PREFIX)) {
        sessionStorage.removeItem(storageKey);
      }
    });
  } catch {
    // ignore
  }
};
